import { useState } from 'react';

const LoginPrompt = ({ onSuccess }) => {
    const [password, setPassword] = useState('');
    const [error, setError] = useState(false);
    const [shakeAnimation, setShakeAnimation] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();

        const correctPassword = process.env.REACT_APP_ACCESS_PASSWORD;

        if (!correctPassword) {
            console.error('REACT_APP_ACCESS_PASSWORD is not set in environment variables');
            setError(true);
            return;
        }

        if (password === correctPassword) {
            sessionStorage.setItem('authenticated', 'true');
            onSuccess();
        } else {
            setError(true);
            setShakeAnimation(true);
            setPassword('');
            setTimeout(() => setShakeAnimation(false), 500);
        }
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-100 to-gray-200 flex items-center justify-center p-4">
            <div className={`bg-white rounded-lg shadow-2xl p-8 w-full max-w-md ${shakeAnimation ? 'animate-shake' : ''}`}>
                {/* PCC Logo/Header */}
                <div className="text-center mb-6">
                    <div className="bg-pcc-cardinal text-white rounded-lg py-4 px-6 mb-4">
                        <h1 className="text-2xl font-bold">PCC Class Search</h1>
                        <p className="text-sm mt-1 opacity-90">Pasadena City College</p>
                    </div>
                    <p className="text-gray-600 text-sm">
                        Enter your access code to continue
                    </p>
                </div>

                {/* Login Form */}
                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-2">
                            Access Code
                        </label>
                        <input
                            type="password"
                            id="password"
                            value={password}
                            onChange={(e) => {
                                setPassword(e.target.value);
                                setError(false);
                            }}
                            className={`w-full px-4 py-3 border-2 rounded-lg focus:outline-none focus:ring-2 transition-all ${
                                error
                                    ? 'border-red-500 focus:ring-red-500'
                                    : 'border-gray-300 focus:ring-pcc-cardinal focus:border-pcc-cardinal'
                            }`}
                            placeholder="Enter access code"
                            autoFocus
                            autoComplete="off"
                        />
                        {error && (
                            <p className="text-red-600 text-sm mt-2 flex items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" viewBox="0 0 20 20" fill="currentColor">
                                    <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                                </svg>
                                Incorrect access code. Please try again.
                            </p>
                        )}
                    </div>

                    <button
                        type="submit"
                        className="w-full bg-pcc-cardinal hover:bg-pcc-cardinal-dark text-white font-semibold py-3 px-4 rounded-lg transition-all transform hover:scale-[1.02] active:scale-[0.98] focus:outline-none focus:ring-2 focus:ring-pcc-cardinal focus:ring-offset-2"
                    >
                        Access Class Search
                    </button>
                </form>

                {/* Footer Note */}
                <div className="mt-6 pt-4 border-t border-gray-200">
                    <p className="text-xs text-gray-500 text-center">
                        Authorized access only. For assistance, contact your administrator.
                    </p>
                </div>
            </div>

            <style>{`
                @keyframes shake {
                    0%, 100% { transform: translateX(0); }
                    25% { transform: translateX(-10px); }
                    75% { transform: translateX(10px); }
                }
                .animate-shake {
                    animation: shake 0.5s;
                }
            `}</style>
        </div>
    );
};

export default LoginPrompt;
